// Use this as a sample to add to $context["pathway_config"] in the project
const domain_name = "https://system.spektrix";
const client_name = "";
const site_url = "";

const defaultConfig = {
  SITE_URL: site_url,
  AJAX_URL: null,
  DOMAIN_NAME: domain_name,
  CLIENT_NAME: client_name,
  SPEKTRIX_API_URL: `${domain_name}/${client_name}/api/v3`,
  SPEKTRIX_PLUGIN_URL: `${site_url}/wp-content/uploads/cog-wp-spektrix`,
  INSTANCE: null,
  EVENT: null,
  INSTANCE_ID: null,
  PLAN_ID: null,
  SUPPLEMENTARY_INSTANCES: null,
  ATTRIBUTES: null,
  HAS_BEST_AVAILABLE: null,
  LOGO_URLS: {
    // To add venue specific logos add them to this object with keys that match the venue attributes
    site: null,
  },
  TAGS: [],
  COLORS: [
    "#FA4F00", // orange-red
    "#3971E2", // strong blue
    "#109121", // forest green
    "#E912B7", // bright pink
    "#D70007", // deep red
    "#7677A6", // slate
    "#8E33FF", // purple
    "#EC5F73", // pink-red
    "#2E8267", // dark teal
    "#9520AA", // dark purple
    "#FFEA33", // bright yellow
    "#33FF76", // mint green
    "#D99020", // muted orange
    "#33FFD7", // aqua
    "#E22B15", // red-orange
    "#FFBD33", // warm yellow
    "#10B6A9", // teal
    "#AAC800", // olive green
    "#ED60FF", // light magenta
    "#00C73F", // vivid green
    "#FC8308", // orange
    "#1FDAFF", // sky blue
    "#33A1FF", // light blue
    "#A1FF33", // lime green
  ],
  USE_IFRAME_ACCOUNT: true,
  ACCOUNT_AREAS: [
    {
      title: "Account Overview",
      description: "",
      link: "/account",
      icon: "",
    },
    {
      title: "Orders & tickets",
      description: "View orders and download tickets",
      link: "/account/orders",
      icon: "ticket",
    },
    {
      title: "Membership & offers",
      description: "View and edit your membership",
      link: "/account/memberships",
      icon: "idcard",
    },
    {
      title: "Help & FAQs",
      description: "View more information",
      link: "/account/help",
      icon: "questionmark",
    },
    {
      title: "Preferences",
      description: "View and edit your preferences",
      link: "/account/preferences",
      icon: "cog",
    },
    {
      title: "My details",
      description: "View and edit your account details ",
      link: "/account/details",
      icon: "avatar",
    },
    {
      title: "Payments",
      description: "View and edit your card details",
      link: "/account/payments",
      icon: "card",
    },
  ],
  WALLET_NAME: "",
  PRIORITY_ACCESS: null,
  OPTION_FIELDS: {},
};

export default defaultConfig;
